export default (string: string) => {
    let street = ''
    let nr = ' '
    let addition = ''

    // Only a hyphen after a house number separates the addition (12-II), hyphens in street names (Sint-Jansstraat) stay
    // Shopify separates street and house number with an invisible word joiner (U+2060), which \s does not match
    let baseAddress = string.replace(/\u2060/g, ' ').trim().replace(',', '').replace(/([0-9])-/, '$1 ')

    const address = baseAddress.split(/\s+/)

    if (address.length > 2) {
        if (address[address.length - 2].match(/[0-9]/)) {
            addition = address.pop()
            nr = address.pop()
            street = address.join(' ')
        } else if (address[address.length - 1].match(/[0-9]/)) {
            nr = address.pop()
            street = address.join(' ')
        } else if (address[0].match(/[0-9]/)) {
            nr = address.shift()
            street = address.join(' ')
        } else {
            street = address.join(' ')
        }
    } else if (address.length > 1) {
        if (address[address.length - 1].match(/[0-9]/)) {
            nr = address.pop()
            street = address.join(' ')
        } else if (address[0].match(/[0-9]/)) {
            nr = address.shift()
            street = address.join(' ')
        } else {
            street = address.join(' ')
        }
    } else {
        street = address.join(' ')
    }

    if (!addition) {
        const nrAddition = nr.match(/[0-9]+|[^0-9]/gi)

        if (nrAddition.length > 1) {
            nr = nrAddition.shift()
            addition = nrAddition.join('')
        }
    }

    if (/[0-9]/.test(addition[0])) {
        addition = `-${addition}`
    }

    addition = addition.toUpperCase()

    return {street: street.trim(), nr: nr.trim(), addition: addition.trim()}
}
